import { storableError } from '../../util/errors';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

// ================ Action types ================ //

export const FETCH_LESSONS_REQUEST = 'app/MyLessonsPage/FETCH_LESSONS_REQUEST';
export const FETCH_LESSONS_SUCCESS = 'app/MyLessonsPage/FETCH_LESSONS_SUCCESS';
export const FETCH_LESSONS_ERROR = 'app/MyLessonsPage/FETCH_LESSONS_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
    entities.map(entity => ({
        id: entity.id,
        type: entity.type,
    }));

const initialState = {
    fetchInProgress: false,
    fetchLessonsError: null,
    pagination: null,
    transactionRefs: [],
};

export default function myLessonsPageReducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_LESSONS_REQUEST:
            return { ...state, fetchInProgress: true, fetchLessonsError: null };
        case FETCH_LESSONS_SUCCESS: {
            const transactions = payload.data.data;
            return {
                ...state,
                fetchInProgress: false,
                transactionRefs: entityRefs(transactions),
                pagination: payload.data.meta,
            };
        }
        case FETCH_LESSONS_ERROR:
            console.error(payload); // eslint-disable-line
            return { ...state, fetchInProgress: false, fetchLessonsError: payload };

        default:
            return state;
    }
}

// ================ Action creators ================ //

const fetchLessonsRequest = () => ({ type: FETCH_LESSONS_REQUEST });
const fetchLessonsSuccess = response => ({
    type: FETCH_LESSONS_SUCCESS,
    payload: response,
});
const fetchLessonsError = e => ({
    type: FETCH_LESSONS_ERROR,
    error: true,
    payload: e,
});

// ================ Thunks ================ //

export const loadData = (params, search) => (dispatch, getState, sdk) => {
    dispatch(fetchLessonsRequest());

    const apiQueryParams = {
        only: 'order',
        lastTransitions: getAllTransitionsForEveryProcess(),
        include: [
            'listing',
            'provider',
            'provider.profileImage',
            'customer',
            'customer.profileImage',
            'booking',
        ],
        'fields.transaction': [
            'processName',
            'lastTransition',
            'lastTransitionedAt',
            'transitions',
            'payinTotal',
            'payoutTotal',
            'lineItems',
        ],
        'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType', 'publicData'],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
        page: 1,
        perPage: 100,
        sort: '-createdAt',
    };

    return sdk.transactions
        .query(apiQueryParams)
        .then(response => {
            dispatch(addMarketplaceEntities(response));
            dispatch(fetchLessonsSuccess(response));
            return response;
        })
        .catch(e => {
            dispatch(fetchLessonsError(storableError(e)));
            throw e;
        });
};
